/**
 * System Date Service
 * Fetches the authoritative system date for a client.
 */

import { APIClient, APIResponse } from './client';
import { SystemDateInfo } from '../../types/systemDate';

const apiClient = new APIClient();

export const systemDateService = {
  async getSystemDate(clientId: string): Promise<APIResponse<SystemDateInfo>> {
    return apiClient.get<SystemDateInfo>(`/api/v1/system-date/${clientId}`);
  },
};
